import { render } from "./AppTopBar.vue?vue&type=template&id=d2e3b4a2"
import script from "./AppTopBar.vue?vue&type=script&lang=js"
export * from "./AppTopBar.vue?vue&type=script&lang=js"

import "./AppTopBar.vue?vue&type=style&index=0&id=d2e3b4a2&lang=scss"

import exportComponent from "/data/www/shoptok-analytics/frontend/live/live_224/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__